import React, { type ReactNode } from 'react';
import { Box } from '../box/tw';
import { Text } from '../text/tw';
import { hotkey, type HotkeyVariantProps } from './Hotkey.variants';

export interface HotkeyT extends HotkeyVariantProps {
  children?: ReactNode;
}

export const Hotkey = ({ children, checked, hasIcon }: HotkeyT) => (
  <Box className={hotkey({ checked, hasIcon })}>
    {hasIcon ? (
      children
    ) : (
      <Text className="text-inherit font-semibold">{children}</Text>
    )}
  </Box>
);
